import { styled } from '@mui/system';
import { Button, Typography } from '@mui/material';
import { colors } from '../../constants/theme';

export const StyledCtaButton = styled(Button)({
  paddingLeft: 28,
  paddingRight: 28,
  paddingTop: 10,
  paddingBottom: 10,
  borderRadius: 12,
  backgroundColor: '#29405A',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#29405A',
  },
});

export const StyledCtaText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})(({ theme, disabled }) => ({
  ...theme.typography.subtext,
  fontSize: 10,
  color: disabled ? colors.text : colors.whiteText,
  fontWeight: 500,
  [theme.breakpoints.up('md')]: {
    fontSize: 20,
  },
}));
